
import React from 'react'
import { Row, Col, Typography, Tooltip, Button } from 'antd';
import { getfilteredCountries } from '../../../utils/Constants';
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";

const { Title } = Typography;

const TravellersCardCollapseTripjack = ({
    selectPayloadData,
    handleEditClick,
}) => {

    const { travellerInfo } = selectPayloadData || {};


    const getTagColor = (paxType) => {
        switch (paxType) {
            case 1:
                return 'blue';
            case 2:
                return 'orange';
            case 3:
                return 'green';
            default:
                return 'gray';
        }
    };

    const getCountryNameByCode = (code) => {
        const country = getfilteredCountries.find(country => country.code === code);
        return country ? country.name : 'Unknown';
    };

    return (

        <div className="max-w-3xl mx-auto px-4">
            <div className="booking-details lastBorder">
                <div title="" className="traveller-card">
                    <div className="d-flex justify-content-between align-items-center">
                        <Title level={5} className='mt-2'>Review Details</Title>
                        <div className='d-flex justify-content-center py-3'>
                            <Button
                                onClick={handleEditClick}
                                className="btn btn-primary menu-block rounded m-auto d-flex align-items-center justify-content-center"
                            >
                                <EditOutlined />
                                Edit
                            </Button>
                        </div>
                    </div>

                    <Row gutter={16} style={{ overflowY: 'auto', maxHeight: '420px', padding: '5px 0' }}>
                        {travellerInfo?.map((traveller, index) => (
                            <Col key={index} xs={24} sm={24} lg={24}>
                                <div className="card traveller-info-card">
                                    <div className='card-header py-2'>
                                        <h3 style={{ color: getTagColor(traveller.pt) }}>
                                            <b>{traveller.pt === 1 ? 'ADULT' : traveller.pt === 2 ? 'CHILD' : 'INFANT'}</b>
                                        </h3>
                                        <p>Traveller {index + 1}</p>
                                    </div>
                                    <div className='card-body'>
                                        <p className="d-flex align-items-center justify-content-between border-bottom mb-1 pb-1">
                                            <span>Title:</span> <strong>{traveller?.ti || 'N/A'}</strong>
                                        </p>
                                        <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>First Name :</span> <strong>{traveller?.fN}</strong></p>
                                        <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Last Name :</span> <strong>{traveller?.lN}</strong></p>
                                        {traveller?.dob && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Date of Birth :</span> <strong>{moment(traveller?.dob).format("MMM DD, YYYY")}</strong></p>}
                                        {traveller?.pNum && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Passport Number :</span> <strong>{traveller?.pNum}</strong></p>}
                                        {traveller?.pNat && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Nationality :</span> <strong>{getCountryNameByCode(traveller?.pNat)}</strong></p>}
                                        {traveller?.pid && <p className='d-flex align-items-center justify-content-between border-bottom mb-1 pb-1'><span>Passport Issuing  Date :</span> <strong>{moment(traveller?.pid).format("MMM DD, YYYY")}</strong></p>}
                                        {traveller?.eD && <p className='d-flex align-items-center justify-content-between'><span>Passport Expiry Date :</span> <strong>{moment(traveller?.eD).format("MMM DD, YYYY")}</strong></p>}
                                    </div></div>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </div>

    )
}

export default TravellersCardCollapseTripjack